import { render, staticRenderFns } from "./dataCollect.vue?vue&type=template&id=266f513f&"
import script from "./dataCollect.vue?vue&type=script&lang=js&"
export * from "./dataCollect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/components/statistics/dataCollect.vue"
export default component.exports